<template>
	<div class="wrapper">
		<side-bar v-if="$store.state.authentication.account_type == 'adm'">
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>Dashboard</p>
			</sidebar-link>
			<sidebar-link to="/loans">
				<md-icon>request_quote</md-icon>
				<p>Loans</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>Clients</p>
			</sidebar-link>
			<sidebar-link to="/calendar">
				<md-icon>date_range</md-icon>
				<p>Calendar</p>
			</sidebar-link>
			<sidebar-link to="/transactions">
				<md-icon>payments</md-icon>
				<p>Transactions</p>
			</sidebar-link>
			<!-- <sidebar-link to="/search">
				<md-icon>article</md-icon>
				<p>Reports</p>
			</sidebar-link> -->
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>Settings</p>
			</sidebar-link>
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>Administrators</p>
			</sidebar-link>
		</side-bar>

		<side-bar v-if="$store.state.authentication.account_type == 'cli'">
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>ផ្ទាំងសង្ខេប</p>
			</sidebar-link>
			<sidebar-link to="/my_loans">
				<md-icon>request_quote</md-icon>
				<p>ការកម្ជីរបស់ខ្ញុំ</p>
			</sidebar-link>
			<sidebar-link to="/profile">
				<md-icon>person</md-icon>
				<p>ព័ត៌មានរបស់ខ្ញុំ</p>
			</sidebar-link>
			<sidebar-link to="/change_password">
				<md-icon>settings</md-icon>
				<p>ផ្លាស់ប្តូរពាក្យសំងាត់</p>
			</sidebar-link>
			<sidebar-link to="/logout">
				<md-icon>logout</md-icon>
				<p>ចាកចេញ</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue